import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import Agb from '../components/Agb'

export default ({ location, data, pageContext }) => (
  <Layout
    pageTitle={data.allContentfulPagePrivacyPolicy.edges[0].node.pageTitle}
    location={location}
    locale={pageContext.locale}
  >
    <Agb data={data.allContentfulPagePrivacyPolicy.edges[0].node} />
  </Layout>
)

export const policyQuery = graphql`
  query($locale: String) {
    allContentfulPagePrivacyPolicy(filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          pageTitle
          content {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
